import { CONTENT_TYPE } from '../../utils/constant';
import { encodeBase64 } from '../../utils/utilityFunctions';
import { CALL_API } from '../middleware';
import {
    ECAS_DOWNLOAD,
    ECAS_DOWNLOAD_SUCCESS,
    ECAS_UPLOAD_FILE,
    ECAS_UPLOAD_FILE_SUCCESS,
    ecasDownloadRequestBody,
    GET_REPORT_LIST_ECAS,
    GET_REPORT_LIST_ECAS_SUCCESS,
    GetReportListEcasRequestBody,
    GetReportListEcasResponseBody,
    SEND_OTP_ECAS,
    SEND_OTP_ECAS_SUCCESS,
    SendOtpEcasRequestBody,
    SendOtpEcasResponseBody,
    VALIDATE_QR,
    VALIDATE_QR_SUCCESS,
    VERIFY_OTP_ECAS,
    VERIFY_OTP_ECAS_SUCCESS,
    VerifyOtpEcasRequestBody,
    VerifyOtpEcasResponseBody
} from '../types/eCasDownloads';

export const sendOtpEcas =
    (body: SendOtpEcasRequestBody) =>
        async (dispatch: any): Promise<SendOtpEcasResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    // url: '/onboarding/mfc/sendOTP',
                    url: '/onboarding/mfc/generate-cas-request',
                    method: 'POST',
                    types: [SEND_OTP_ECAS_SUCCESS, SEND_OTP_ECAS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const verifyOtpEcas =
    (body: VerifyOtpEcasRequestBody) =>
        async (dispatch: any): Promise<VerifyOtpEcasResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/mfc/verifyOTP',
                    method: 'POST',
                    types: [VERIFY_OTP_ECAS_SUCCESS, VERIFY_OTP_ECAS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const getReportListEcas =
    (body: GetReportListEcasRequestBody) =>
        async (dispatch: any): Promise<GetReportListEcasResponseBody> => {
            return await dispatch({
                [CALL_API]: {
                    // url: '/onboarding/mfc/reportList',
                    url: '/onboarding/mfc/refresh-requests',
                    method: 'POST',
                    types: [GET_REPORT_LIST_ECAS_SUCCESS, GET_REPORT_LIST_ECAS],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };

export const ecasDownload =
    (body: ecasDownloadRequestBody) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/mfc/download',
                    method: 'POST',
                    types: [ECAS_DOWNLOAD_SUCCESS, ECAS_DOWNLOAD],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                    contentType: CONTENT_TYPE.EXCEL
                },
            });
        };


export const eCasUploadFile = (body: FormData) =>
    async (dispatch: any): Promise<{ success: boolean; message: string }> => {
        return await dispatch({
            [CALL_API]: {
                url: '/mfc/cas-parser/parse-ecas',
                method: 'POST',
                types: [ECAS_UPLOAD_FILE_SUCCESS, ECAS_UPLOAD_FILE],
                body,
            }
        });
    };

    export const validateMFCQR =
    (body: {
        qrCode: string;
        reqId: string;
    }) =>
        async (dispatch: any): Promise<any> => {
            return await dispatch({
                [CALL_API]: {
                    url: '/onboarding/mfc/validate-qr',
                    method: 'POST',
                    types: [VALIDATE_QR_SUCCESS, VALIDATE_QR],
                    body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
                },
            });
        };